import { AdDirective } from '@goatsports/shared/util';

export const clearViewContainerRef = (adHost: AdDirective) => {
  const viewContainerRef = adHost.viewContainerRef;
  viewContainerRef.clear();
  return viewContainerRef;
};
